import { personService } from '@/services/person.service'

export default {
    name: 'PersonDialogDriverCodeTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        },
        update:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // para activar el overlay que indica que el driverCode puede usarse o no
        loadingAlreadyAssignedDriverCode: false,
        // para mostrar un ícono de éxito o error en la validación de códigos de conductores
        driverCodeSuccess: null,
        // mensajes de error del campo para ingresar el driverCode
        driverCodeErrorMsgs: [],
        // datos de la persona para reasignar el código de conductor
        personDriverCodeDuplicated: {
            _id: null,
            name: null
        }
    }),
    computed: {
        /**
         * Ícono de validación del driver code
         */
        driverCodeValidationIcon () {
            if (this.driverCodeSuccess == null || this.model.driverCode == null || this.model.driverCode === '') {
                return 'mdi-blank'
            } else {
                return this.isValidForm && (this.driverCodeSuccess || this.model.reassignment) ? 'mdi-check-circle' : 'mdi-close-circle'
            }
        },
        /**
         * Color del ícono de validación del driver code
         */
        driverCodeValidationIconColor () {
            return this.isValidForm && (this.driverCodeSuccess || this.model.reassignment) ? 'success' : 'error'
        },
    },
    created () {
    },
    mounted () {
    },
    methods: {
        /**
         * Para validar el código de conductor
         */
        driverCodeDuplicatedMethod () {
            if (!this.model.driverCode) {
                this.driverCodeSuccess = null
                this.driverCodeErrorMsgs = []
                this.model.reassignment = false
                this.model.personIdDriverCodeUnset = null
            } else {
                this.loadingAlreadyAssignedDriverCode = true
                const that = this
                personService.validateDriverCode(this.model.driverCode, this.model._id).then(response => {
                    that.driverCodeSuccess = response.validation
                    that.personDriverCodeDuplicated = response.person != null ? response.person : { _id: null, name: null }
                    if (!that.driverCodeSuccess) {
                        that.driverCodeErrorMsgs.push(that.$t('person.error.driverCodeAlreadyAssigned'))
                        that.model.personIdDriverCodeUnset = this.personDriverCodeDuplicated._id
                    } else {
                        that.driverCodeErrorMsgs = []
                        that.model.reassignment = false
                        that.model.personIdDriverCodeUnset = null
                    }
                    that.loadingAlreadyAssignedDriverCode = false
                })
            }
        },
        /**
         * Re-asignación de código de conductor
         */
        driverCodeReassignment () {
            this.model.reassignment = !this.model.reassignment
            if (this.model.reassignment) {
                this.driverCodeErrorMsgs = []
            } else {
                this.driverCodeErrorMsgs.push(this.$t('person.error.driverCodeAlreadyAssigned'))
            }
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm (newVal, oldVal) {
            if (newVal!==oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.personDialogDriverCodeTabForm) {
                this.$refs.personDialogDriverCodeTabForm.resetValidation()
            }
        }
    }
}
